import React from 'react'
import gql from 'graphql-tag'
import { Mutation, MutationFn } from 'react-apollo'

export const approvalWorkflowSettingsMutation = gql`
  mutation updateApprovalWorkflowSettings(
    $organizationID: ID!
    $enabled: Boolean!
    $statuses: [String!]!
    $severities: [String!]!
  ) {
    updateApprovalWorkflowSettings(
      input: {
        organizationID: $organizationID
        settings: {
          enabled: $enabled
          statuses: $statuses
          severities: $severities
        }
      }
    ) {
      _placeholder
    }
  }
`

interface ChildProps {
  readonly children: (
    updateSettings: MutationFn<{}, UpdateApprovalWorkflowSettingsMutationArgs>
  ) => React.ReactNode
}

export interface UpdateApprovalWorkflowSettingsMutationArgs {
  readonly organizationID: string
  readonly enabled: boolean
  readonly statuses: string[]
  readonly severities: string[]
}

export function ApprovalWorkflowSettingsMutation({ children }: ChildProps) {
  return (
    <Mutation<{}, UpdateApprovalWorkflowSettingsMutationArgs>
      mutation={approvalWorkflowSettingsMutation}
    >
      {(updateWorkflowSettings) => {
        return children(updateWorkflowSettings)
      }}
    </Mutation>
  )
}
